import gql from 'graphql-tag';

export const addDispensaryCustomer = gql`
  mutation AddDispensaryCustomer($input: dispensaryCustomerInput!) {
    addDispensaryCustomer(customer: $input) {
      success
      message
    }
  }
`;

export const updateDispensaryCustomer = gql`
  mutation UpdateDispensaryCustomer($input: dispensaryCustomerInput!) {
    updateDispensaryCustomer(customer: $input) {
      success
      message
    }
  }
`;

export const exportDispensaryCustomers = gql`
  mutation ExportDispensaryCustomers($input: customerExportInput!) {
    exportDispensaryCustomers(input: $input) {
      success
      message
    }
  }
`;

export const exportCustomerReport = gql`
  mutation ExportCustomerReport($export: exportCustomerReportInput!) {
    exportCustomerReport(export: $export) {
      success
      count
    }
  }
`;

export const emailDispensaryCustomerList = gql`
  mutation EmailDispensaryCustomerList($input: customerImportInput!) {
    emailDispensaryCustomerList(input: $input) {
      success
      message
    }
  }
`;

export const updateCustomerSubscription = gql`
  mutation UpdateCustomerSubscription($customerId: String!, $subscribed: Boolean!) {
    updateCustomerSubscription(customerId: $customerId, subscribed: $subscribed) {
      success
    }
  }
`;

export const unsubscribeDispensaryCustomers = gql`
  mutation UnsubscribeDispensaryCustomers($input: unsubscribeDispensaryCustomersInput!) {
    unsubscribeDispensaryCustomers(input: $input) {
      success
    }
  }
`;
